module.exports = __webpack_public_path__ + "static/media/expressiveSpace-small.3ad031a4.jpg";